///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { gridPopupsRoute } from './users-grid.route';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { UsersGridComponent } from './users-grid.component';
import { GtthShareComponentsModule } from '../shared/shared-components.module';
import { GtthShareDirectivesModule } from '../shared/shared-directives.module';
import { GtthSharedCommonModule } from '../shared/shared-common.module';
import { UsersListStoreModule } from './store/users-list-store.module';
import { UserService } from './service/user.service';
import { UserDialogComponent } from './dialogs/create-or-edit/user-dialog.component';
import { UserDeleteDialogComponent } from './dialogs/delete/user-delete-dialog.component';
import { DeleteUserDialogWrapperComponent } from './dialogs/delete/delete-user-dialog-wrapper.component';
import { CreateUserDialogWrapperComponent } from './dialogs/create-or-edit/create-user-dialog-wrapper.component';
import { EditUserDialogWrapperComponent } from './dialogs/create-or-edit/edit-user-dialog-wrapper.component';
import { DeleteSaleDialogWrapperComponent } from './dialogs/delete/delete-sale-dialog-wrapper.component';
import { SaleDeleteDialogComponent } from './dialogs/delete/sale-delete-dialog.component';
import { GridDirectivesModule } from '../shared/directives/grid-directives/grid-directives.module';
import { ContextSensitiveHelpComponent } from '../shared/context-sensitive-help/ctx-sensitive-help.component';
import {
    SuiLoadingDirective,
    SuiPaginationComponent,
    SuiPasswordControlComponent,
    SuiRadioGroupControlComponent,
    SuiSelectControlComponent,
    SuiStringControlComponent,
    SuiSvgIconComponent,
    SuiTooltipDirective,
    SuiTranslatePipe
} from '@siklu/sui-lib';

const ENTITY_STATES = [...gridPopupsRoute];

@NgModule({
    imports: [
        CommonModule,
        MatDialogModule,
        GtthShareComponentsModule,
        GtthShareDirectivesModule,
        GtthSharedCommonModule,
        UsersListStoreModule,
        RouterModule.forChild(ENTITY_STATES),
        GridDirectivesModule,
        ContextSensitiveHelpComponent,
        SuiLoadingDirective,
        SuiSvgIconComponent,
        SuiTranslatePipe,
        SuiStringControlComponent,
        SuiPasswordControlComponent,
        SuiRadioGroupControlComponent,
        SuiSelectControlComponent,
        SuiTooltipDirective,
        SuiPaginationComponent
    ],
    declarations: [
        UsersGridComponent,
        UserDialogComponent,
        UserDeleteDialogComponent,
        SaleDeleteDialogComponent,
        CreateUserDialogWrapperComponent,
        EditUserDialogWrapperComponent,
        DeleteUserDialogWrapperComponent,
        DeleteSaleDialogWrapperComponent
    ],
    exports: [UsersGridComponent],
    providers: [UserService]
})
export class UsersGridModule {}
